var map = {
	"./dev.config.json": 830,
	"./prod.config.json": 831,
	"./qa.config.json": 832,
	"./stg.config.json": 833
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.json$
// module id = 829
// module chunks = 0